// extracted by mini-css-extract-plugin
export default {"filtersContainer":"Header__filtersContainer___ANXVI"};